module.exports = __webpack_public_path__ + "img/kma_gallery0.773803cd.jpg";